var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainCareworker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 349,
    viewBox: "0 0 248 349",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1135_62444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.565 349.342C183.997 349.342 176.608 348.517 168.398 346.867C143.22 340.265 124.063 325.137 110.927 301.483C95.602 307.534 79.7293 308.909 63.3092 305.608C46.3418 301.758 31.8374 292.956 19.7961 279.203C5.018 262.15 -1.55 242.346 0.0920045 219.792C1.18668 196.687 10.2177 177.708 27.1851 162.855C33.2058 157.904 39.7738 152.128 46.8892 145.527C53.4572 138.375 60.5726 131.224 68.2353 124.073C81.3713 110.87 95.0547 97.3922 109.285 83.6395C124.063 69.8868 138.294 57.7844 151.978 47.3323C161.282 40.1809 170.04 33.8547 178.25 28.3536C187.007 22.8525 195.217 18.1765 202.88 14.3258C231.341 0.573031 259.255 -3.27774 286.622 2.77347C317.82 11.5752 339.44 31.6542 351.481 63.0104C359.144 85.0148 358.87 108.119 350.66 132.324C349.566 135.075 348.471 137.825 347.376 140.576C346.282 143.326 344.913 146.352 343.271 149.653C362.975 159.004 377.206 174.408 385.964 195.862C393.626 217.866 392.805 239.32 383.501 260.225C374.196 280.579 358.597 294.606 336.703 302.308C319.736 308.909 304.137 314.96 289.906 320.461C275.675 325.412 263.634 329.538 253.782 332.839C248.309 335.039 243.109 336.965 238.183 338.615C233.804 340.265 230.247 341.641 227.51 342.741C222.037 343.841 216.29 345.216 210.269 346.867C204.248 348.517 197.68 349.342 190.565 349.342Z",
    fill: "#CEFDE3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1135_62444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 349,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainCareworker);
export default __webpack_public_path__ + "static/media/main_careworker.43c9aa8187a65c3ea13d20aab4ad329c.svg";
export { ForwardRef as ReactComponent };